import { Box, Flex, forwardRef, Text, BoxProps } from '@chakra-ui/react';
import { dataAttr } from '@chakra-ui/shared-utils';

import { IComboboxFilterItemProps } from '@/interfaces/search';

interface IComboboxProps extends BoxProps {
  item: IComboboxFilterItemProps;
  isHighlighted: boolean;
}

export const FilterComboboxItem = forwardRef<IComboboxProps, 'div'>(({ item, isHighlighted, ...rest }, ref) => {
  const amount = item.amount ? `(${item.amount})` : '';

  return (
    <Box
      fontSize="md"
      fontWeight="semibold"
      lineHeight="short"
      transition="background-color 220ms, color 220ms"
      _hover={{
        color: 'violet.400',
        bg: 'gray.50',
      }}
      data-highlighted={dataAttr(isHighlighted)}
      _highlighted={{
        bg: 'gray.100',
      }}
      py={3}
      cursor="pointer"
      {...rest}
      ref={ref}
    >
      <Flex w="100%" justify="space-between">
        <Box>
          {item.subTitle && (
            <Text fontSize="sm" color="gray.500" mb={2}>
              {item.subTitle}
            </Text>
          )}
          <Text>
            {item.title} {amount}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
});
